import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReunioesService } from '../../services/reunioes.service';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { AuthService } from 'src/app/shared/services/auth.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlteraSenhaComponent } from 'src/app/core/altera-senha/altera-senha.component';
import { Location } from '@angular/common';


@Component({
  selector: 'app-nav-tabs-apresentacao',
  templateUrl: './nav-tabs-apresentacao.component.html',
  styleUrls: ['./nav-tabs-apresentacao.component.scss']
})
export class NavTabsApresentacaoComponent  implements OnInit {
  id:number;
  nomeUsuario: string;
  orgaoUsuario: string;
  modalRef: BsModalRef;
  fontSize:number = null;
  currentRoute:string = '';
  title:string = '';
  statusAdm:boolean = false;
  showFilters:boolean = false;
  statusFullScreen = false;
  elem:any = null;
  data:object[] = [
    {'id':'pauta','label':'Pauta', 'file': this.setFilePath('pauta.svg')},
    {'id':'quadro-geral','label':'Quadro geral', 'file': this.setFilePath('quadrogeral.svg')},
    {'id':'projetos','label':'Projetos', 'file': this.setFilePath('projeto.svg')},
    {'id':'demandas','label':'Demandas', 'icon': 'view_list', 'showOnlyInAdm':true},
    {'id':'anexos','label':'Anexos', 'icon': 'attach_file', 'showOnlyInAdm':true},
    {'id':'participantes','label':'Participantes', 'icon': 'group', 'showOnlyInAdm':true},
    {'id':'registro','label':'Registro', 'file': this.setFilePath('registro.svg')}
  ];

  constructor(
      private router: Router,
      public activatedRoute: ActivatedRoute,
      public reunioesService: ReunioesService,
      private storage: StorageService,
      private sanitizer: DomSanitizer,
      private navigation: NavigationService,
      private location: Location,
      private authService: AuthService,
      private bsModalService: BsModalService
    ) {
    }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.id = +params.get('id');
      this.title = params.get('type');
    });
    console.log(this.title)
    var storedFont  = sessionStorage.getItem('fontSize' + this.id); 
    if(!storedFont){
      storedFont = '1.5';
      sessionStorage.setItem('fontSize' + this.id, storedFont);
    }
    this.fontSize = +storedFont;
    this.statusAdm = sessionStorage.getItem('statusMeeting' + this.id) == "true";
    this.start();
  }

  start(){
    var user_info = this.storage.getInfoUser();
    this.nomeUsuario = user_info?.str_nome;
    let matches = this.nomeUsuario?.match(/\(([^)]+)\)/);
    if (matches) {
      let usuario = this.nomeUsuario?.replace(matches[0], "").trim();
      let orgao = matches[1];
      this.nomeUsuario = usuario;
      this.orgaoUsuario = orgao;
    };
  }

  setFilePath(filePath: string) {
    const fullPath = `assets/images/svgs/${filePath}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }
  isActive(route: string): boolean {
    if(this.router.routerState.snapshot.url.includes(route)){
      this.currentRoute = route;
      return true;
    }
    return false;
  }

  navigate(route:string){

    const urlSegments = this.router.url.split('/');
    var currentRoute = urlSegments[urlSegments.length - 1];
    var currentUrl = this.router.routerState.snapshot.url;
    var newUrl = currentUrl.replace(currentRoute, route);
    this.router.navigateByUrl(newUrl);
  }

  print(){
    alert('TODO Ainda falta o design, ficara para a proxima entrega');
  }
  get currentTitle(): string{
    var storedDataString  = sessionStorage.getItem('dataMeeting' + this.id); 
    var storedData = JSON.parse(storedDataString);
    return storedData?.acMeeting?.description;
  }
  
  setFont(sum:boolean){
    if(sum){
      this.fontSize += 0.1;
    }
    else{
      if (this.fontSize > 0.5) {
        this.fontSize -= 0.1; 
      }
    }
    sessionStorage.setItem('fontSize' + this.id, this.fontSize.toString());
  }
  
  voltar() {
    var isSlide = this.router.routerState.snapshot.url.includes('indicador')
    if(isSlide){
      this.location.back();
    }
    else{
      this.navigation.back([`reuniao/reunioes`]);
    }
  }
  
  navReunioes(){
    this.router.navigate(['/reuniao/reunioes']);
  }

  setStatus(){
    this.statusAdm = !this.statusAdm;
    sessionStorage.setItem('statusMeeting' + this.id, (this.statusAdm).toString());
    window.location.reload();
  }
  
  openFullscreen() {
    this.elem = document.documentElement;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
    else{ 
      alert("Erro ao abrir modo Apresentação. Utilize o Fn + F11 para abrir.");
    }
    
    this.statusFullScreen = true;
  }
  closeFullscreen() {
    var doc:any = document;
    if (doc.exitFullscreen) {
      doc.exitFullscreen();
    } else if (doc.mozCancelFullScreen) {
      /* Firefox */
      doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      doc.webkitExitFullscreen();
    } else if (doc.msExitFullscreen) {
      /* IE/Edge */
      doc.msExitFullscreen();
    }
    else{ 
      alert("Erro ao sair do modo Apresentação. Utilize o ESC para sair.");
    }
    this.statusFullScreen = false;
  }

  alterarSenha(){
      this.router.navigate(['/alterar-senha']);
    }
  
    alterarSenhaDialog() {
      this.modalRef = this.bsModalService.show(AlteraSenhaComponent, {
        class: 'modal-lg',
      });
    }
  
    vincularSoe() {
      this.authService.soewebVincularAuthentication()
        .then((redirecUrl) => {
          window.location.href = redirecUrl;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  
    vincularDropbox() {
      this.authService.dropboxVincularAuthentication()
        .then((redirecUrl) => {
          window.location.href = redirecUrl;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  
    signout() {
      this.router.navigate(['logout']);
    }
}
